<template>
    <bottom-sheet v-model="shows" title="지원자 정보" fullscreen persistent width="1224" maxWidth="100%">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <div class="mb-20 mb-lg-40" style="flex: 0 0 auto;">
                <application-view-title v-bind="{ value }" class="mb-12 mb-lg-26" />
                <v-tabs v-model="tab" class="v-tabs--underline">
                    <v-tab>이력서</v-tab>
                    <v-tab>마이스펙이력 ({{ micepecRecordsLength }})</v-tab>
                    <v-tab>추가질문답변</v-tab>
                    <v-tab>문자보내기</v-tab>
                    <v-tab>메모하기</v-tab>
                    <v-tab v-if="isRecruit">마이스펙인증</v-tab>
                </v-tabs>
            </div>
            <v-tabs-items v-model="tab" touchless class="h-100 scroll-primary pr-10" style="flex: 0 1 auto; overflow-y: auto; overflow-x: hidden;">
                <tab-resume :value="value?.resume" />
                <tab-micepec-records v-bind="{ value }" />
                <tab-questions v-bind="{ value }" />
                <tab-textings v-bind="{ value, recruitment }" />
                <tab-memo :application="value" />
                <tab-certify v-bind="{ value, recruitment }" @input="(item) => $emit('input', item)" />
            </v-tabs-items>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import { APPLICATION_STAGES } from "@/assets/variables";

import TabMemo from "./tab-memo.vue";
import TabResume from "./tab-resume.vue";
import TabCertify from "./tab-certify.vue";
import TabTextings from "./tab-textings.vue";
import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import TabQuestions from "./tab-questions.vue";
import TabMicepecRecords from "./tab-micepec-records.vue";
import ApplicationViewTitle from "./application-view-title.vue";

export default {
    components: {
        TabMemo,
        TabResume,
        TabCertify,
        TabTextings,
        BottomSheet,
        TabQuestions,
        TabMicepecRecords,
        ApplicationViewTitle,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // application
        recruitment: { type: Object, default: () => ({}) },
    },
    data: () => ({
        shows: false,
        tab: 0,
    }),
    computed: {
        micepecRecordsLength() {
            return this.value?._micepecRecords?.length || 0;
        },
        isRecruit() {
            return this.value?.stage == APPLICATION_STAGES.ON_RECRUIT.value;
        },
    },
};
</script>

<style>
</style>